import { Content } from '@app/models/Content';
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class PmcDataService {
    pmcLogo: Content;
    pmcName: string;
    pmcCoupon: string;

    dataChange = new Subject<any>();

    setPmcCoupon(coupon: string) {
        let tempCoupon = this.pmcCoupon;
        this.pmcCoupon = coupon;
        if(coupon !== null &&  coupon !== undefined) {
            this.dataChange.next({
                property: 'PmcCoupon',
                oldValue: tempCoupon,
                newValue: coupon,
            })
        }
    }

    getPmcCoupon(): string {
        return this.pmcCoupon;
    }

    setPmcName(name: string) {
        this.pmcName = name;
    }

    getPmcName(): string {
        return this.pmcName;
    }

    setPmcLogo(logo: Content) {
        this.pmcLogo = logo;
    }

    getPmcLogo(): Content {
        return this.pmcLogo;
    }

}

